module.exports = __webpack_public_path__ + "img/2c49edb.png";